import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getCurrentRef } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useOccAccessibilityText } from '../../../../context/occ/hooks/use-occ-accessibility-text';
import { useOccDisplayText } from '../../../../context/occ/hooks/use-occ-display-text';
import { useFieldValidator } from '../../../../hooks/use-field-validator';
import { isEmailSuggestionFieldValidationResult } from '../../../../utils/form/field-validation-result';
import { getFormFieldErrorMessage } from '../../form-field-utils';
import { Input } from '../../input/input/input';
import { Field } from '../field/field';
import { getFieldProps } from '../utils/get-field-props';
import { getInputProps } from '../utils/get-input-props';
import { InputFieldInternalAction } from './types/internal-action';
const b = bemClassBuilder('v-input-field');
export const InputField = observer(props => {
    const i18n = useI18n();
    const { displayText, validationConfig, validate, error } = props;
    const inputRef = useRef(null);
    const { form: formDisplayText } = useOccDisplayText();
    const accessibilityText = useOccAccessibilityText();
    const errorMessage = getFormFieldErrorMessage(error, displayText, i18n, validationConfig, undefined, formDisplayText, accessibilityText);
    const fieldValidatorState = useFieldValidator(validate || (() => Promise.resolve(undefined)), // 'validate' is optional, so just pass validation if not provided.
    props.setHelpText, errorMessage);
    const fieldProps = getFieldProps(Object.assign(Object.assign({}, props), { b, helpText: errorMessage }));
    const inputProps = getInputProps(props, fieldValidatorState, errorMessage);
    const acceptEmailSuggestion = () => {
        var _a;
        if (!isEmailSuggestionFieldValidationResult(error)) {
            return;
        }
        (_a = inputProps.onChangeValue) === null || _a === void 0 ? void 0 : _a.call(inputProps, error.value || ''); // Use onChangeValue from getInputProps to ensure the field is revalidated.
        const input = getCurrentRef(inputRef);
        input.focus();
    };
    const internalActions = [
        {
            name: InputFieldInternalAction.AcceptEmailSuggestion,
            action: acceptEmailSuggestion
        }
    ];
    return (_jsx(Field, Object.assign({}, fieldProps, { internalActions: internalActions, children: _jsx(Input, Object.assign({ ref: inputRef }, inputProps)) })));
});
InputField.displayName = 'InputField';
//# sourceMappingURL=input-field.js.map